import { Character, GameInstance, GameItem, MapNode } from "../../../types";
import { EquipSlot } from "../../../types/CharacterTypes";
import { Monster } from "../../../types/LogicTypes";
import { expGameInstance } from "../ThreeTestFC";

export const getSubMap = (game: GameInstance, charId: string): string | undefined => {
    return game.characterLocations.find(l => l.charId === charId)?.subInstanceId
}

export const equipSlotName = (e: EquipSlot): string => {
    if (e === "head") { return "Head" }
    if (e === "body") { return "Body" }
    if (e === "rhand") { return "Right Hand" }
    if (e === "lhand") { return "Left Hand" }
    return ""
}

export const getNodeCoords = (nodeId: string, subInstanceId?: string): {x: number, y: number} | undefined => {
    const instance = subInstanceId ? expGameInstance?.subInstances.find(s => s.id === subInstanceId) : expGameInstance
    const node = instance?.map.nodes.find(n => n.id === nodeId)
    if (!node) { return }
    return { x: node.x, y: node.y }
}

export const getNode = (nodeId: string, subInstanceId?: string): MapNode | undefined => {
    const instance = subInstanceId ? expGameInstance?.subInstances.find(s => s.id === subInstanceId) : expGameInstance
    const node = instance?.map.nodes.find(n => n.id === nodeId)
    if (!node) { return }
    return node
}

export const getNodeByChar = (game: GameInstance, charId: string): MapNode | undefined => {
    const nodeId = game.characterLocations.find(c => c.charId === charId)?.nodeId
    if (!nodeId) { return }
    const subInstanceId = game.characterLocations.find(c => c.charId === charId)?.subInstanceId
    const node = getNode(nodeId, subInstanceId)
    if (!node) { return }
    return node
}

export const getItemsOnTheGround = (characterId: string): GameItem[] => {
    const subInstanceId = expGameInstance?.characterLocations.find(c => c.charId === characterId)?.subInstanceId
    const instance = subInstanceId ? expGameInstance?.subInstances.find(s => s.id === subInstanceId) : expGameInstance
    const nodeId = instance?.characterLocations.find(c => c.charId === characterId)?.nodeId
    return instance?.items.filter(i => i.nodeId === nodeId).map(i => i.item) ?? []
}

export const getGameDataForCombat = (gameInstance: GameInstance, character: Character): { gameInstance: GameInstance, character: Character, monster: Monster } | undefined => {
    if (!character || !gameInstance) { console.error("no char"); return; }
    const baseLocation = gameInstance.characterLocations.find(c => c.charId === character.id)
    if (!character.combatStatus.combatActive) { return }
    const instance = baseLocation?.subInstanceId ? gameInstance.subInstances.find(s => s.id === baseLocation.subInstanceId) : gameInstance
    const instanceLocation = instance?.characterLocations.find(l => l.charId === character.id)
    if (!instance || !instanceLocation) { console.error("no instance"); return; }
    const monster = instance.monsters.find(m => (m.monster.id === character.combatStatus.monsterId && m.nodeId === instanceLocation.nodeId))
    if (!monster) { return; }

    return {
        gameInstance: gameInstance,
        character: character,
        monster: monster.monster,
    }
}

export const getActionCount = (gameInstance: GameInstance, character?: Character): number => {
    let c = 1;
    if (!character) { return 0 }
    // if (character.stats.health < character.stats.base.maxHealth || character.stats.sanity < character.stats.base.maxSanity) {
    //     c += 1;
    // }
    const node = getNodeByChar(gameInstance, character.id)
    const gateId = node?.gateIds && node.gateIds[0]
    const clueIds = node?.clueIds ?? []

    if (gateId) {
        c += 1
    }

    if (clueIds.length > 0) {
        c += 1
    }

    if (character.conditions.find(c => c.name === "detained") !== undefined) {
        c += 1
    }

    if (character.conditions.find(c => c.name === "lost_in_time_and_space") !== undefined) {
        c += 1
    }

    if (character.conditions.find(c => c.name === "debt") !== undefined) {
        c += 1
    }

    return c;
}